import { useCallback } from "react";
import { SavedReport } from "@/entities/savedReports/types";
import { useReportRuns } from "@/components/global/Chat/components/dreamerReports/ReportRunsContext";

/**
 * Opening a report shows it and generates it afresh. A report that cannot be
 * run again opens on its saved result instead. A run already generating for
 * the report is joined rather than started twice; `startRun` decides that.
 */
export const useOpenReport = (
  showReport: (report: SavedReport) => void
) => {
  const { startRun } = useReportRuns();

  return useCallback(
    (report: SavedReport) => {
      if (report.isReplayable) startRun(report.id, report.name || null);
      showReport(report);
    },
    [startRun, showReport]
  );
};
